import { useGetServiceTypesHierarchyIsActiveQuery, useGetServiceTypesHierarchyQuery } from 'services';
import { FindServiceTypeIsActiveWithKeywordDto, FindWithKeywordDto } from 'types';
export function useServiceTypesHierarchy({ keyword }: FindWithKeywordDto) {
  const {
    data: serviceTypesResponse,
    error,
    isLoading,
    isFetching
  } = useGetServiceTypesHierarchyQuery({
    keyword
  });

  return {
    serviceTypesHierarchy: serviceTypesResponse?.data,
    isLoading: isFetching || isLoading,
    error
  };
}
export function useServiceTypesIsActiveHierarchy({ keyword, isActive }: FindServiceTypeIsActiveWithKeywordDto) {
  const {
    data: serviceTypesResponse,
    error,
    isLoading,
    isFetching
  } = useGetServiceTypesHierarchyIsActiveQuery({
    keyword,
    isActive
  });

  return {
    serviceTypesHierarchy: serviceTypesResponse?.data,
    isLoading: isFetching || isLoading,
    error
  };
}
